import {Injectable} from '@angular/core';
import {Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';
import {Question} from 'shared/models/questions/question';
import {IQuestionsOverviewRepository} from './questions-overview.repository.interface';

@Injectable()
export class QuestionsOverviewHttpRepository implements  IQuestionsOverviewRepository {

  constructor(private http: Http) { }

  public getQuestions(): Observable<Array<Question>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(environment.questions, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public deleteQuestion(id: string): Observable<void> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.delete(`${environment.questions}/${id}`, options)
      .map((response: Response) => {
        return;
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-overview/repositories/questions-overview.repository.http.ts